module.exports = __webpack_public_path__ + "static/media/dark_ru.d0d62e8b.svg";